<template>
  <div>
    <div>
      <b-container class="px-0 bg-white-border">
        <div class="p-3">
          <div class="header-container">
            <div class="mr-2">
              <b-button-group class="buttongroup-custom w-100">
                <b-button
                  :class="[
                    tabIndex === 1 ? 'button-active' : 'button-noactive',
                  ]"
                  @click="onClickTab(1)"
                  >Day</b-button
                >
                <b-button
                  :class="[
                    tabIndex === 2 ? 'button-active' : 'button-noactive',
                  ]"
                  @click="onClickTab(2)"
                  >Week</b-button
                >
                <b-button
                  :class="[
                    tabIndex === 3 ? 'button-active' : 'button-noactive',
                  ]"
                  @click="onClickTab(3)"
                  >Month</b-button
                >
              </b-button-group>
            </div>
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                mb-2
                my-md-0
              "
            >
              <span class="f-size-12">DATE: FORM </span>
              <div class="date-container">
                <datetime
                  class="date-picker"
                  value-zone="Asia/Bangkok"
                  placeholder="yyyy-mm-dd"
                  v-model="filter.startDate"
                  @close="onSelectDate"
                ></datetime>
              </div>
              <span class="f-size-12"> TO </span>
              <div class="date-container mr-0">
                <datetime
                  class="date-picker"
                  value-zone="Asia/Bangkok"
                  placeholder="yyyy-mm-dd"
                  v-model="filter.endDate"
                  @close="onSelectDate"
                ></datetime>
              </div>
            </div>
          </div>

          <div class="my-4">
            <b-row class="no-gutters">
              <b-col cols="12" sm="4">
                <div class="mr-0 mb-4 mb-sm-0 mr-sm-2 stat-container">
                  <p><font-awesome-icon icon="user-check" /> Active User</p>
                  <span>{{ widgetData.activeUserFormat }}</span>
                </div>
              </b-col>
              <b-col cols="12" sm="4">
                <div class="m-0 mb-4 mb-sm-0 mx-sm-2 stat-container">
                  <p><font-awesome-icon icon="user-plus" /> New User</p>
                  <span>{{ widgetData.newUserFormat }}</span>
                </div>
              </b-col>
              <b-col cols="12" sm="4">
                <div class="m-0 ml-sm-2 stat-container">
                  <p><font-awesome-icon icon="robot" /> Bot Knowledge</p>
                  <span>{{ widgetData.botKnowledge }} Percent</span>
                </div>
              </b-col>
            </b-row>
          </div>

          <b-row class="no-gutters my-3">
            <b-col cols="12" xl="6" class="mb-3 mb-xl-0 row-container">
              <div class="mr-xl-2 bg-white p-3 h-100">
                <div class="mb-2">
                  <b-row>
                    <b-col cols="6" class="d-flex align-items-center">
                      <strong>การตอบกลับข้อความ</strong>
                    </b-col>
                    <b-col
                      cols="6"
                      class="d-flex align-items-center justify-content-end"
                    >
                      <b-button
                        class="button-export"
                        @click="exportResponseMessage()"
                        >Export to Excel</b-button
                      >
                    </b-col>
                  </b-row>
                </div>
                <div v-if="isResponseMessageLoading">
                  <div class="text-center">
                    <img
                      src="@/assets/images/icons/loading.svg"
                      alt="loading"
                      class="mb-3 img"
                      width="50px"
                      height="50px"
                    />
                  </div>
                </div>
                <div v-else class="my-3">
                  <ResponseMessageChart
                    :data="dataResponseMessage"
                    :yAxisTitle="yAxisTitle"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="12" xl="6">
              <div class="ml-xl-2 row-container p-3 h-100">
                <div class="mb-2">
                  <b-row>
                    <b-col cols="6" class="d-flex align-items-center">
                      <strong>ภาพรวมผู้เข้าใช้งาน</strong>
                    </b-col>
                    <b-col
                      cols="6"
                      class="d-flex align-items-center justify-content-end"
                    >
                      <b-button class="button-export" @click="exportUserActive()"
                        >Export to Excel</b-button
                      >
                    </b-col>
                  </b-row>
                </div>
                <div v-if="isUserActiveLoading">
                  <div class="text-center">
                    <img
                      src="@/assets/images/icons/loading.svg"
                      alt="loading"
                      class="mb-3 img"
                      width="50px"
                      height="50px"
                    />
                  </div>
                </div>
                <div v-else class="my-3">
                  <BarChartUserActive
                    :data="dataUserActive"
                    :yAxisTitle="yAxisTitle"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="no-gutters my-3">
            <b-col cols="12" xl="6" class="mb-3 mb-xl-0 row-container">
              <div class="mr-xl-2 bg-white p-3 h-100">
                <div class="mb-2">
                  <b-row>
                    <b-col cols="6" class="d-flex align-items-center">
                      <strong>Monthly Top Intent</strong>
                    </b-col>
                    <b-col
                      cols="6"
                      class="d-flex align-items-center justify-content-end"
                    >
                      <b-button class="button-export" @click="exportMonthIntent"
                        >Export to Excel</b-button
                      >
                    </b-col>
                  </b-row>
                </div>
                <div v-if="isMonthIntentLoading">
                  <div class="text-center">
                    <img
                      src="@/assets/images/icons/loading.svg"
                      alt="loading"
                      class="mb-3 img"
                      width="50px"
                      height="50px"
                    />
                  </div>
                </div>
                <div v-else class="my-3">
                  <BarChartMonthIntent
                    :data="dataMonthIntent"
                    :yAxisTitle="yAxisTitle"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="12" xl="6">
              <div class="ml-xl-2 row-container p-3 h-100">
                <div class="mb-2">
                  <b-row>
                    <b-col cols="6" class="d-flex align-items-center">
                      <strong>User Channel</strong>
                    </b-col>
                    <b-col
                      cols="6"
                      class="d-flex align-items-center justify-content-end"
                    >
                      <b-button class="button-export" @click="exportChannelIntent"
                        >Export to Excel</b-button
                      >
                    </b-col>
                  </b-row>
                </div>
                <div v-if="isChannelLoading">
                  <div class="text-center">
                    <img
                      src="@/assets/images/icons/loading.svg"
                      alt="loading"
                      class="mb-3 img"
                      width="50px"
                      height="50px"
                    />
                  </div>
                </div>
                <div v-else class="my-3">
                  <LineChartChannelIntent
                    :data="dataChannelIntent"
                    :yAxisTitle="yAxisTitle"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import BarChartUserActive from "./components/BarChartUserActive.vue";
import BarChartMonthIntent from "./components/BarChartMonthIntent.vue";
import ResponseMessageChart from "./components/ResponseMessageChart.vue";
import LineChartChannelIntent from "./components/LineChartChannelIntent.vue";
import moment from "moment";
export default {
  components: {
    BarChartUserActive,
    BarChartMonthIntent,
    ResponseMessageChart,
    LineChartChannelIntent,
  },
  name: "Chart",
  data: function() {
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    startDate.setUTCHours(0, 0, 0, 0);
    const endDate = new Date();
    endDate.setUTCHours(0, 0, 0, 0);
    return {
      isResponseMessageLoading: true,
      isUserActiveLoading: true,
      isMonthIntentLoading: true,
      isChannelLoading: true,
      dataResponseMessage: {
        adminResponse: [],
        messageResponse: [],
        messageIn: [],
      },
      dataUserActive: [],
      dataMonthIntent: [],
      dataChannelIntent: [],
      startDate: "",
      yAxisTitle: "สัปดาห์",
      endDate: "",
      tabIndex: 2,
      filter: { startDate: "", endDate: "", ViewAs: 2 },
      widgetData: {
        activeUser: 0,
        botKnowledge: 0,
        newUser: 0,
      },
    };
  },
  methods: {
    onSelectDate() {
      if (this.filter.startDate && this.filter.endDate) {
        this.getAllData();
      }
    },
    getResponseMessage: async function() {
      this.isResponseMessageLoading = true;
      const url = `${this.$baseUrl}/analytics/ResponseMessage`;
      await this.axios
        .post(url, this.filter)
        .then((data) => {
          if (data.result === 1) {
            const dataLists = data.detail.length > 0 ? data.detail : [];
            const adminResponse = dataLists.map((e) => {
              return {
                name: e.label,
                count: e.adminResponse,
                countFormat: e.adminResponseFormat,
              };
            });
            const messageResponse = dataLists.map((e) => {
              return {
                name: e.label,
                count: e.messageResponse,
                countFormat: e.messageResponseFormat,
              };
            });
            const messageIn = dataLists.map((e) => {
              return {
                name: e.label,
                count: e.messageIn,
                countFormat: e.messageInFormat,
              };
            });
            const dataResult = {
              adminResponse,
              messageResponse,
              messageIn,
            };
            this.dataResponseMessage = dataResult;
            this.isResponseMessageLoading = false;
          }
        })
        .catch((error) => {
          this.dataResponseMessage = {};
          this.isResponseMessageLoading = false;
        });
    },
    getUserActive: async function() {
      this.isUserActiveLoading = true;
      const url = `${this.$baseUrl}/analytics/UserActive`;
      await this.axios
        .post(url, this.filter)
        .then((data) => {
          if (data.result === 1) {
            const dataLists = data.detail.length > 0 ? data.detail : [];
            const count = dataLists.map((e) => {
              return {
                count: e.count,
                countFormat: e.countFormat,
                monthName: e.monthName,
              };
            });
            this.dataUserActive = count;
            this.isUserActiveLoading = false;
          }
        })
        .catch((error) => {
          this.dataUserActive = [];
          this.isUserActiveLoading = false;
        });
    },
    getMonthIntent: async function() {
      this.isMonthIntentLoading = true;
      const url = `${this.$baseUrl}/analytics/monthIntent`;
      await this.axios
        .post(url, this.filter)
        .then((data) => {
          if (data.result === 1) {
            const dataLists = data.detail.length > 0 ? data.detail : [];
            const chartDatas = dataLists.map((e) => {
              return {
                percent: e.percent,
                percentFormat: e.percentFormat,
                name: e.name,
                count: e.count,
              };
            });
            //show only first 1-10 intent
            this.dataMonthIntent = chartDatas.slice(0, 10);
            this.isMonthIntentLoading = false;
          }
        })
        .catch((error) => {
          this.dataMonthIntent = [];
          this.isMonthIntentLoading = [];
        });
    },
    getChannelIntent: async function() {
      this.isChannelLoading = true;
      const url = `${this.$baseUrl}/analytics/UserChannel`;
      await this.axios
        .post(url, this.filter)
        .then((data) => {
          if (data.result === 1) {
            const dataLists = data.detail.length > 0 ? data.detail : [];
            const lineChannel = dataLists.map((e) => {
              return {
                name: e.label,
                count: e.line,
                countFormat: e.lineFormat,
              };
            });
            const mobileChannel = dataLists.map((e) => {
              return {
                name: e.label,
                count: e.mobile,
                countFormat: e.mobileFormat,
              };
            });
            const webChannel = dataLists.map((e) => {
              return {
                name: e.label,
                count: e.web,
                countFormat: e.webFormat,
              };
            });
            const dataResult = {
              lineChannel,
              mobileChannel,
              webChannel,
            };
            this.dataChannelIntent = dataResult;
            this.isChannelLoading = false;
          }
        })
        .catch((error) => {
          this.dataChannelIntent = {};
          this.isChannelLoading = false;
        });
    },
    exportResponseMessage: async function() {
      const url = `${this.$baseUrl}/analytics/ExportResponseMessage`;
      await this.axios.post(url, this.filter, {
          responseType: "blob",
        }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response]));
        var fileLink = document.createElement("a");
        var dateExcel = moment().format("DDMMYYYYhhmmss");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `Response Message -` + dateExcel + `.xlsx`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },
    exportUserActive: async function() {
      const url = `${this.$baseUrl}/analytics/ExportUserActive`;
      await this.axios.post(url, this.filter, {
          responseType: "blob",
        }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response]));
        var fileLink = document.createElement("a");
        var dateExcel = moment().format("DDMMYYYYhhmmss");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `User Active -` + dateExcel + `.xlsx`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },
    exportMonthIntent: async function() {
      const url = `${this.$baseUrl}/analytics/ExportMonthIntent`;
      await this.axios.post(url, this.filter, {
          responseType: "blob",
        }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response]));
        var fileLink = document.createElement("a");
        var dateExcel = moment().format("DDMMYYYYhhmmss");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `Month Intent -` + dateExcel + `.xlsx`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },
    exportChannelIntent: async function() {
      const url = `${this.$baseUrl}/analytics/ExportUserChannel`;
      await this.axios.post(url, this.filter, {
          responseType: "blob",
        }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response]));
        var fileLink = document.createElement("a");
        var dateExcel = moment().format("DDMMYYYYhhmmss");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `Channel Intent -` + dateExcel + `.xlsx`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },
    onClickTab: async function(idx) {
      this.tabIndex = idx;
      this.filter.ViewAs = idx;
      switch (idx) {
        case 1:
          this.yAxisTitle = "วัน";
          break;
        case 2:
          this.yAxisTitle = "สัปดาห์";
          break;
        case 3:
          this.yAxisTitle = "เดือน";
          break;
        default:
          this.yAxisTitle = "สัปดาห์";
      }
      await this.getAllData();
    },
    getWidget: async function() {
      const url = `${this.$baseUrl}/analytics/Widget`;
      await this.axios.post(url, this.filter).then((data) => {
        if (data.result === 1) {
          this.widgetData = data.detail;
        }
      });
    },
    getAllData: async function() {
      await this.getResponseMessage();
      await this.getUserActive();
      await this.getMonthIntent();
      await this.getChannelIntent();
      await this.getWidget();
    },
  },
  mounted: async function() {
    this.filter.startDate = moment(new Date())
      .subtract(2, "months")
      .format();
    this.filter.endDate = moment().format();
    await this.getAllData();
  },
};
</script>

<style lang="scss" scoped>
.f-size-12 {
  font-size: 12px;
}

.date-container {
  max-width: 35%;
  margin: 0 0.5rem;
}

.row-container {
  border: 1px solid #dedede;
}

.stat-container {
  padding: 1rem;
  border-radius: 4px;
  background: #e2dff3;
  color: #3c4b64;
}

.header-container {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}

.button-export {
  background-color: transparent;
  color: #404040;
}

.button-export:hover {
  background-color: #7d6da8 !important;
  color: #fefefe;
}

@media (max-width: 720px) {
  .header-container {
    flex-direction: column-reverse;
  }
}
</style>
